import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-mb-2 tw-rounded tw-border tw-bg-white" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-px-3 tw-py-4" }
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = {
  key: 0,
  class: "tw-p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerChevronRight = _resolveComponent("TablerChevronRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tw-flex tw-items-center tw-justify-between tw-pr-3", {
        'tw-border-b': _ctx.isModuleOpen,
        'tw-cursor-not-allowed': _ctx.isCurrentModuleInValid,
        'tw-cursor-pointer': !_ctx.isCurrentModuleInValid
      }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickModule && _ctx.onClickModule(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TablerChevronRight, {
          class: _normalizeClass({
            'tw-mr-2 tw-h-4 tw-w-4': true,
            'tw-rotate-90': _ctx.isModuleOpen
          })
        }, null, 8, ["class"]),
        _createElementVNode("h2", {
          class: "tw-text-xs tw-font-semibold",
          "data-testid": _ctx.title.replaceAll(' ', '-').toLowerCase()
        }, _toDisplayString(_ctx.title), 9, _hoisted_3)
      ]),
      (_ctx.isModuleOpen && _ctx.hasTooltipSlot)
        ? _renderSlot(_ctx.$slots, "tooltip", {
            key: 0,
            class: "tw-z-50"
          })
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.isModuleOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "main")
        ]))
      : _createCommentVNode("", true)
  ]))
}